import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";

export class AgentSkillsDisplayListCtrl implements IController {
  ids: any;
  isRow: any;
  onChange: Function;

  public skills;
  public siteSkills;

  /* @ngInject */
  constructor(private splitService: SplitService) {
    this.siteSkills = this.splitService.getSiteResourceSkills();
  }

  $onInit() {
    this._setSkills();
  }

  $onChanges(changes) {
    if (changes.ids) {
      this.$onInit();
    }
  }

  onRemove(id) {
    this.onChange({
      ids: _.filter(this.ids, (i) => {
        return i !== id
      })
    });
  }

  private _setSkills() {
    this.skills = _.map(this.ids, (sId) => {
      return this.siteSkills[sId];
    });
  }


}

angular
  .module('bringoz.admin.agents')
  .component('agentSkillsDisplayList', {
    bindings: {
      ids: '<',
      isRow: '<?',
      onChange: '&'
    },
    template: require('./agent-skills-display-list.html').default,
    controller: AgentSkillsDisplayListCtrl
  });
